var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "trial-end-clock",
        {
          attrs: {
            title: _vm.$t.__("common.labels.account_is_now_inactive"),
            subtitles: [
              _vm.$t.__("common.labels.subscription_expired"),
              _vm.$t.__(
                "pages.errors.BasicCartAvailable.to_continue_validate_offer"
              )
            ]
          }
        },
        [
          _c(
            "a",
            {
              staticClass:
                "primary-50-bkg white br fs-4 lh-24 pt-2 pb-2 pl-4 pr-4 semibold",
              attrs: {
                href: _vm.cartLink,
                target: _vm.provider === "chargebee" ? "_blank" : "_self"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.multipleQuotes
                      ? _vm.$l10n.__("Consulter mes offres")
                      : _vm.$l10n.__("Valider mon offre")
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "typographies-paragraph-medium-semibold help-message__container"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Nous vous invitons à prendre contact avec nos conseillers via le"
                    )
                  ) +
                  "\n            "
              ),
              _c("CompassLink", {
                attrs: {
                  label: _vm.$t.__("pages.errors.BasicCartAvailable.tchat"),
                  size: "large",
                  link: "javascript:;"
                },
                on: {
                  click: function($event) {
                    return _vm.window.MySupport.getForm()
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }